(function (global) {
  'use strict';
  const WORD = /[\p{L}\p{N}\p{M}_]/u;
  const BLOCKED = 'a,script,style,noscript,template,textarea,input,select,button,form,nav,aside,header,footer,code,pre,svg,math,[contenteditable],[hidden],[aria-hidden="true"],[role="navigation"],[role="button"],[data-no-autolink],[data-pt-no-autolink],.price,.product-count,.facets,.breadcrumbs,.card-wrapper,.product-card-wrapper,.cart-drawer,.menu-drawer';
  const PROSE = '.rte,.metafield-rich_text_field,[data-pt-autolinks-content],.product__description,.collection__description,.article-template__content,.rich-text__text,p,li,td,th,blockquote';
  const normalize = p => { try { return decodeURIComponent(new URL(p, 'https://local.invalid').pathname).replace(/\/+$/, '') || '/'; } catch { return p; } };
  const pathMatch = (p, pattern) => {
    const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*');
    return new RegExp('^' + escaped + '$').test(p);
  };
  function safeURL(url) {
    return typeof url === 'string' && /^\/(?!\/)/.test(url) && !/[\s<>"'\\\x00-\x1f]/.test(url) && !/%(?:00|0a|0d|2f|5c)/i.test(url);
  }
  function eligible(rule, context) {
    const path = normalize(context.path);
    return rule.enabled !== false && rule.locale === context.locale && safeURL(rule.url) &&
      (!rule.countries?.length || rule.countries.includes(context.country)) &&
      (!rule.types?.length || rule.types.includes(context.type)) && normalize(rule.url) !== path &&
      (!rule.include?.length || rule.include.some(p => pathMatch(path, p))) &&
      !rule.exclude?.some(p => pathMatch(path, p));
  }
  function compile(rules, context) {
    const trie = { next: new Map(), ends: [] };
    for (const rule of rules.filter(r => eligible(r, context))) {
      for (const keyword of rule.keywords || []) {
        if (!keyword || keyword.length > 500) continue;
        let node = trie;
        for (const char of Array.from(keyword)) {
          const key = char.toLowerCase();
          if (!node.next.has(key)) node.next.set(key, { next: new Map(), ends: [] });
          node = node.next.get(key);
        }
        node.ends.push({ rule, keyword });
      }
    }
    return trie;
  }
  function matches(text, trie) {
    const chars = Array.from(text), offsets = []; let offset = 0;
    for (const char of chars) { offsets.push(offset); offset += char.length; }
    offsets.push(offset);
    const found = [], seen = new Set();
    for (let start = 0; start < chars.length; start++) {
      let node = trie;
      for (let end = start; end < chars.length; end++) {
        node = node.next.get(chars[end].toLowerCase()); if (!node) break;
        for (const item of node.ends) {
          const { rule, keyword } = item;
          if (rule.case_sensitive && text.slice(offsets[start], offsets[end + 1]) !== keyword) continue;
          if (rule.whole_words !== false && ((WORD.test(chars[start]) && start && WORD.test(chars[start - 1])) || (WORD.test(chars[end]) && end + 1 < chars.length && WORD.test(chars[end + 1])))) continue;
          const key = `${rule.id}:${start}:${end}`;
          if (!seen.has(key)) { seen.add(key); found.push({ start: offsets[start], end: offsets[end + 1], rule }); }
        }
      }
    }
    return found;
  }
  function scan(root, config, context) {
    if (!config.enabled || (config.exclude || []).some(p => pathMatch(normalize(context.path), p))) return [];
    const trie = compile(config.rules || [], context), doc = root.ownerDocument;
    const walker = doc.createTreeWalker(root, 4), candidates = []; let node, chars = 0, index = 0;
    const protectedSelector = BLOCKED + (config.exclude_headings !== false ? ',h1,h2,h3,h4,h5,h6' : '');
    while ((node = walker.nextNode())) {
      if (++index > 12000 || (chars += node.data.length) > 500000) break;
      const parent = node.parentElement;
      if (!parent || parent.closest(protectedSelector) || !parent.closest(PROSE) || !node.data.trim()) continue;
      if (global.getComputedStyle && global.getComputedStyle(parent).display === 'none') continue;
      for (const match of matches(node.data, trie)) {
        candidates.push({ ...match, node, order: index });
        if (candidates.length >= 20000) break;
      }
      if (candidates.length >= 20000) break;
    }
    // Count variants at the same position as one occurrence, before applying SkipScatter.
    candidates.sort((a, b) => a.order - b.order || a.start - b.start || b.end - a.end);
    const occurrences = new Map(), lastPosition = new Map();
    for (const c of candidates) {
      const key = c.rule.id, position = `${c.order}:${c.start}`;
      if (lastPosition.get(key) !== position) { occurrences.set(key, (occurrences.get(key) || 0) + 1); lastPosition.set(key, position); }
      c.occurrence = occurrences.get(key);
    }
    candidates.sort((a, b) => (b.rule.priority || 0) - (a.rule.priority || 0) || (b.end - b.start) - (a.end - a.start) || a.order - b.order || a.start - b.start || a.rule.id - b.rule.id);
    const accepted = [], counts = new Map(), targets = new Map();
    for (const c of candidates) {
      if (accepted.length >= Math.min(100, config.max_links || 12)) break;
      const rule = c.rule, occurrence = c.occurrence - (rule.skip || 0) - 1;
      if (occurrence < 0 || occurrence % (rule.every || 1)) continue;
      if ((counts.get(rule.id) || 0) >= (rule.max || 1) || (targets.get(normalize(rule.url)) || 0) >= (rule.max || 1)) continue;
      if (accepted.some(a => a.node === c.node && a.start < c.end && c.start < a.end)) continue;
      accepted.push(c); counts.set(rule.id, (counts.get(rule.id) || 0) + 1); targets.set(normalize(rule.url), (targets.get(normalize(rule.url)) || 0) + 1);
    }
    return accepted;
  }
  function apply(root, config, context) {
    for (const link of root.querySelectorAll('a[data-pt-autolink]')) link.replaceWith(link.ownerDocument.createTextNode(link.textContent));
    root.normalize();
    const result = scan(root, config, context), nodes = new Map();
    for (const match of result) { if (!nodes.has(match.node)) nodes.set(match.node, []); nodes.get(match.node).push(match); }
    for (const [node, list] of nodes) {
      list.sort((a, b) => a.start - b.start); let offset = 0;
      const fragment = node.ownerDocument.createDocumentFragment();
      for (const match of list) {
        fragment.append(node.ownerDocument.createTextNode(node.data.slice(offset, match.start)));
        const a = node.ownerDocument.createElement('a'); a.setAttribute('href', match.rule.url);
        a.textContent = node.data.slice(match.start, match.end); a.dataset.ptAutolink = String(match.rule.id);
        if (['fade','brighten','scale','underline-slide','underline-center','glow','background-slide','highlight-slide','color-pop'].includes(config.hover)) a.className = 'pt-interlinks-hover-' + config.hover;
        if (match.rule.new_tab) a.target = '_blank';
        const rel = [match.rule.new_tab ? 'noopener noreferrer' : '', match.rule.nofollow ? 'nofollow' : ''].filter(Boolean).join(' ');
        if (rel) a.rel = rel;
        if (/^#[a-f\d]{6}$/i.test(config.color || '')) a.style.color = config.color;
        if (config.underline !== false) { a.style.textDecoration = 'underline'; a.style.textUnderlineOffset = '0.15em'; }
        fragment.append(a); offset = match.end;
      }
      fragment.append(node.ownerDocument.createTextNode(node.data.slice(offset))); node.replaceWith(fragment);
    }
    return result.map(m => ({ id: m.rule.id, keyword: m.node.data.slice(m.start, m.end), url: m.rule.url }));
  }
  function related(path, suggestions) {
    let decoded; try { decoded = decodeURIComponent(path); } catch { decoded = path; }
    const stop = new Set(['products','product','collections','collection','pages','page','blogs','blog','webbutik','shop','www','html','pooltime']);
    const words = [...new Set(decoded.replace(/[^\p{L}\p{N}]+/gu,' ').toLowerCase().split(' ').filter(w => w.length > 2 && !stop.has(w)))];
    return suggestions.filter(s => safeURL(s.url) && normalize(s.url) !== normalize(path)).map(s => {
      const target = (s.title + ' ' + s.url).toLowerCase(), matched = words.filter(w => target.includes(w));
      const score = matched.reduce((n,w) => n + Math.min(10,w.length),0);
      return { ...s, score, matches: matched.length };
    }).filter(s => s.matches >= 2 || (s.matches === 1 && s.score >= 6)).sort((a,b) => b.score-a.score || a.title.length-b.title.length).slice(0,5);
  }
  const api = { compile, matches, scan, apply, eligible, safeURL, normalize, pathMatch, related };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.PooltimeInterlinks = api;
  if (!global.document || !global.PooltimeInterlinksConfig) return;
  const script = document.currentScript, config = global.PooltimeInterlinksConfig;
  const context = { locale: script?.dataset.locale || document.documentElement.lang.split('-')[0], country: script?.dataset.country || '', type: script?.dataset.type || 'page', path: location.pathname };
  if (['nb','nn'].includes(context.locale)) context.locale = 'no';
  if (location.hostname.replace(/^www\./, '') !== config.host?.replace(/^www\./, '') || context.locale !== config.locale) return;
  const endpoint = script?.dataset.activity || '';
  const consent = () => config.telemetry === true && navigator.doNotTrack !== '1' && global.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const recorded = new Set();
  const record = (kind, ids) => {
    if (!consent() || !endpoint || !ids.length) return;
    ids = [...new Set(ids)].filter(id => { const key = kind + ':' + id; if (kind === 'view' && recorded.has(key)) return false; recorded.add(key); return true; });
    if (ids.length) navigator.sendBeacon?.(endpoint, new Blob([JSON.stringify({ locale: context.locale, path: context.path, kind, ids: ids.slice(0, 100) })], { type: 'text/plain' }));
  };
  const start = () => {
    const root = document.querySelector('main,#MainContent'); if (!root) return;
    let timer, observer;
    const render = () => {
      observer?.disconnect();
      api.stats = apply(root, config, context); record('view', api.stats.map(s => s.id));
      observer?.observe(root, { childList: true, subtree: true, characterData: true });
    };
    observer = new MutationObserver(mutations => {
      const relevant = mutations.some(m => {
        const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        if (!el || el.closest(BLOCKED)) return false;
        return el.closest(PROSE) || [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches(PROSE) || n.querySelector(PROSE)));
      });
      if (relevant) { clearTimeout(timer); timer = setTimeout(render, 200); }
    });
    render();
    document.addEventListener('shopify:section:load', render);
    document.addEventListener('visitorConsentCollected', () => record('view', (api.stats || []).map(s => s.id)));
    root.addEventListener('click', e => { const a = e.target.closest?.('a[data-pt-autolink]'); if (a) record('click', [Number(a.dataset.ptAutolink)]); });
    if (context.type === '404' && config.recovery_mode !== 'off') {
      const ranked = related(context.path, config.suggestions || []);
      if (config.recovery_mode === 'redirect') {
        const target = ranked[0]?.url || (config.recovery_fallback === 'home' ? '/' : config.recovery_fallback === 'custom' ? config.recovery_url : '');
        if (safeURL(target) && normalize(target) !== normalize(context.path)) {
          if (config.recovery_transparent !== false) { location.replace(target); return; }
          const messages = { sv:'Vi hjälper dig vidare till en aktuell sida.',da:'Vi hjælper dig videre til en aktuel side.',no:'Vi hjelper deg videre til en aktuell side.',fi:'Ohjaamme sinut ajantasaiselle sivulle.',de:'Wir leiten Sie zu einer aktuellen Seite weiter.',en:'We are taking you to a current page.',hu:'Átirányítjuk egy aktuális oldalra.' };
          const p=document.createElement('p'),a=document.createElement('a');a.href=target;a.textContent=messages[context.locale]||messages.en;p.append(a);root.append(p);setTimeout(()=>location.replace(target),1500);return;
        }
      }
      if (config.recovery_mode === 'suggest' && ranked.length) { const list = document.createElement('ul'); list.setAttribute('aria-label','Pooltime'); for (const item of ranked) { const li = document.createElement('li'), a = document.createElement('a'); a.href = item.url; a.textContent = item.title; li.append(a); list.append(li); } root.append(list); }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})(typeof window === 'undefined' ? globalThis : window);
